module.exports = __webpack_public_path__ + "static/media/1920x10801.9924d03e.png";